export default __webpack_public_path__ + "static/media/global-checkin-norefill.2c5d29e3.mp4";